module.exports = __webpack_public_path__ + "static/media/conflict.54628c4e.jpg";